import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// widgets
import WarningNotification from '@/widgets/WarningNotification';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Phrases, MIN_SUGGESTED_PRODUCTS, MIN_SUGGESTED_KEYWORDS, MIN_SUGGESTED_CITIES, } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
import { IconNotificationWarning } from '@/constants/icons/svg';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
// hooks
import useNudge from '@/hooks/useNudge';
// styles
import styles from './WarningNudge.module.scss';
const WarningPill = ({ entity, current, expected, setActiveStep, text, }) => {
    const handlePillClick = () => {
        const entityToStep = {
            Products: 2,
            Cities: 1,
            Keywords: 3,
        };
        setActiveStep(entityToStep[entity]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.warningItem },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_High_Emphasis },
                entity,
                ": ",
                current),
            React.createElement("div", { className: styles.warningPill, onClick: handlePillClick },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, customColor: {
                        dark: tokens.colors.chalk100,
                        light: tokens.colors.chalk100,
                    } }, text
                    ? text
                    : `Add ${Math.max(expected - current, 0)} more`)))));
};
const WarningNudge = ({ adGroupCandidates, adGroupCityIds, adGroupKeywords, onClose, setActiveStep, mode, }) => {
    const { isBroadKeywordNudgeVisible, isCityNudgeVisible, isKeywordNudgeVisible, isProductNudgeVisible, } = useNudge(mode === CampaignWriteModeEnum.EDIT);
    return (React.createElement(WarningNotification, { onClose: onClose, className: styles.warningNotification },
        React.createElement("div", { className: styles.warning },
            React.createElement(IconNotificationWarning, { fillColor: '#5134B6' }),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, Phrases.REVIEW_PAGE)),
                React.createElement("div", { className: styles.warningContent },
                    isProductNudgeVisible ? (React.createElement(WarningPill, { entity: "Products", current: adGroupCandidates, expected: MIN_SUGGESTED_PRODUCTS, setActiveStep: setActiveStep })) : null,
                    isKeywordNudgeVisible ? (React.createElement(WarningPill, { entity: "Keywords", current: adGroupKeywords, expected: MIN_SUGGESTED_KEYWORDS, setActiveStep: setActiveStep })) : null,
                    isBroadKeywordNudgeVisible ? (React.createElement(WarningPill, { text: "Add 1 Broad Keyword", entity: "Keywords", current: adGroupKeywords, expected: MIN_SUGGESTED_KEYWORDS, setActiveStep: setActiveStep })) : null,
                    isCityNudgeVisible ? (React.createElement(WarningPill, { entity: "Cities", current: adGroupCityIds, expected: MIN_SUGGESTED_CITIES, setActiveStep: setActiveStep })) : null)))));
};
export default WarningNudge;
